<template>
	<v-container grid-list-md>
		<v-card flat>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.reservation_max_adults"
							type="number"
							:label="$t('Max Adults for Reservation Form')"
						></v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.reservation_max_children"
							type="number"
							:label="$t('Max Children for Reservation Form')"
						></v-text-field>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					@click="submit()"
					color="primary"
					:loading="item.processing"
				>
					<v-icon left>mdi-content-save</v-icon>
					{{ $t("Save") }}</v-btn
				>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["data"],

	data() {
		return {
			item: this.$inertia.form(this.data),
		};
	},

	methods: {
		async submit() {
			try {
				this.item.post(
					this.$route(
						"tenant.settings.update",
						this.$page.props.tenant.id
					)
				);
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
};
</script>